const styles = {
  container: 'container flex flex-col mb-8',
  title: 'text-[22px] font-bold mb-5',
  wrapper: 'flex items-center justify-between',
  description: 'block max-w-[876px] overflow-hidden my-4 text-base font-normal text-trueGray leading-[25.6px]',
  toggle: 'text-base font-semibold text-primary cursor-pointer',
};

export default styles;
